import useBreakpointCore from "use-breakpoint";

type Breakpoint = keyof typeof BREAKPOINTS;

const BREAKPOINTS = { mobile: 0, desktop: 812 };
const DEFAULT_SSR_BREAKPOINT: Breakpoint = "mobile";

const useBreakpoint = (breakpoint?: Breakpoint) => {
  const breakpointData = useBreakpointCore(
    BREAKPOINTS,
    breakpoint || DEFAULT_SSR_BREAKPOINT
  );

  return {
    ...breakpointData,
    isMobileView: breakpointData.breakpoint === "mobile",
    isDesktopView: breakpointData.breakpoint === "desktop"
  };
};

export default useBreakpoint;
